import styled from "styled-components";
import mapBg from "assets/images/bgnew.png";

export const BgImgWrapper = styled.div`
  width: 100%;
  height: calc(100vw / 1.6);
  position: relative;
  display: block;
  background-image: url(${mapBg});
  background-size: contain;
  background-position-x: center;
  background-position-y: center;
  background-repeat: no-repeat;
  max-width: 1143px;
  max-height: 712px;
  margin: 0 auto;

  ${({ theme }) => theme.mediaWidth.upToXxs`
    height: calc(100vw / 1.6 );
  `}
`;
